import { AnimatePresence, motion } from "framer-motion";

import { useAdonisChat } from "../AdonisChatProvider/AdonisChatProvider";
import { AssistantHeader } from "../components/content/AssistantHeader";

import type { ConversationEngineState } from "./types";

export function EngineMidStreamTypingIndicator({
  state,
}: {
  state: ConversationEngineState;
}) {
  const { persona } = useAdonisChat();

  const showByState =
    state.kind === "preparing_stream" ||
    state.kind === "streaming_tool_calls" ||
    state.kind === "awaiting_tool_responses" ||
    state.kind === "awaiting_ai_continuation";

  return (
    <AnimatePresence>
      {showByState && (
        <motion.div
          className="ml-4 px-4 opacity-100"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.2 }}
        >
          <AssistantHeader persona={persona} isTyping={true} />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
